import { render, staticRenderFns } from "./index-old.vue?vue&type=template&id=558342b1&scoped=true"
import script from "./index-old.vue?vue&type=script&lang=js"
export * from "./index-old.vue?vue&type=script&lang=js"
import style0 from "./index-old.vue?vue&type=style&index=0&id=558342b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558342b1",
  null
  
)

export default component.exports